import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rules: [],
  getRolesLoading: false,
  getRolesSuccess: false,
  getRolesError: null,

  history: [],
  getHistoryLoading: false,
  getHistorySuccess: false,
  getHistoryError: null,

  payFromWalletLoading: false,
  payFromWalletSuccess: false,
  payFromWalletError: null,

  // purchase Addon
  purchaseAddonLoading: false,
  purchaseAddonSuccess: false,
  purchaseAddonError: null,
  addonPurchased: {},

  //stripe purchase
  stripePurchaseLoading: false,
  stripePurchaseSuccess: false,
  stripePurchaseError: null,
  stripePurchase: {},

  //skrill purchase
  skrillPurchaseLoading: false,
  skrillPurchaseSuccess: false,
  skrillPurchaseError: null,
  skrillPurchase: {},
};

const ChallengeRulesReducer = createSlice({
  name: "Challenge Rules",
  initialState,
  reducers: {
    getRulesRequest: (state) => {
      state.getRolesLoading = true;
      state.getRolesSuccess = false;
      state.getRolesError = null;
    },
    getRulesSuccess: (state, action) => {
      state.rules = action.payload;
      state.getRolesLoading = false;
      state.getRolesSuccess = true;
      state.getRolesError = null;
    },
    getRulesErrors: (state, action) => {
      state.getRolesLoading = false;
      state.getRolesSuccess = false;
      state.getRolesError = action.payload;
    },

    getHistoryRequest: (state) => {
      state.getHistoryLoading = true;
      state.getHistorySuccess = false;
      state.getHistoryError = null;
    },
    getHistorySuccess: (state, action) => {
      state.history = action.payload;
      state.getHistoryLoading = false;
      state.getHistorySuccess = true;
      state.getHistoryError = null;
    },
    getHistoryErrors: (state, action) => {
      state.getHistoryLoading = false;
      state.getHistorySuccess = false;
      state.getHistoryError = action.payload;
    },

    payFromWalletRequest: (state) => {
      state.payFromWalletLoading = true;
      state.payFromWalletSuccess = false;
      state.payFromWalletError = null;
    },
    payFromWalletSuccess: (state) => {
      state.payFromWalletLoading = false;
      state.payFromWalletSuccess = true;
      state.payFromWalletError = null;
    },
    payFromWalletErrors: (state, action) => {
      state.payFromWalletLoading = false;
      state.payFromWalletSuccess = false;
      state.payFromWalletError = action.payload;
    },

    // purchase Addon
    purchaseAddonRequest: (state) => {
      state.purchaseAddonLoading = true;
      state.purchaseAddonSuccess = false;
      state.addonPurchased = {};

      state.purchaseAddonError = null;
    },
    purchaseAddonSuccess: (state, action) => {
      state.purchaseAddonLoading = false;
      state.purchaseAddonSuccess = true;
      state.purchaseAddonError = null;
      state.addonPurchased = action.payload;
    },
    purchaseAddonErrors: (state, action) => {
      state.purchaseAddonLoading = false;
      state.purchaseAddonSuccess = false;
      state.addonPurchased = {};
      state.purchaseAddonError = action.payload;
    },

    //stripe purchase
    stripePurchaseRequest: (state) => {
      state.stripePurchaseLoading = true;
      state.stripePurchaseSuccess = false;
      state.stripePurchase = {};
      state.stripePurchaseError = null;
    },
    stripePurchaseSuccess: (state, action) => {
      state.stripePurchaseLoading = false;
      state.stripePurchaseSuccess = true;
      state.stripePurchase = action.payload;
      state.stripePurchaseError = null;
    },
    stripePurchaseErrors: (state, action) => {
      state.stripePurchaseLoading = false;
      state.stripePurchaseSuccess = false;
      state.stripePurchase = {};
      state.stripePurchaseError = action.payload;
    },

    //skrill purchase
    skrillPurchaseRequest: (state) => {
      state.skrillPurchaseLoading = true;
      state.skrillPurchaseSuccess = false;
      state.skrillPurchase = {};
      state.skrillPurchaseError = null;
    },
    skrillPurchaseSuccess: (state, action) => {
      state.skrillPurchaseLoading = false;
      state.skrillPurchaseSuccess = true;
      state.skrillPurchase = action.payload;
      state.skrillPurchaseError = null;
    },
    skrillPurchaseErrors: (state, action) => {
      state.skrillPurchaseLoading = false;
      state.skrillPurchaseSuccess = false;
      state.skrillPurchase = {};
      state.skrillPurchaseError = action.payload;
    },

    clearState: (state) => {
      state.getRolesSuccess = false;
      state.getRolesError = null;

      state.getHistorySuccess = false;
      state.getHistoryError = null;

      state.payFromWalletSuccess = false;
      state.payFromWalletError = null;

      // purchase Addon
      state.purchaseAddonSuccess = false;
      state.purchaseAddonError = null;

      //stripe purchase
      state.stripePurchaseSuccess = false;
      state.stripePurchaseError = null;

      //skrill purchase
      state.skrillPurchaseSuccess = false;
      state.skrillPurchaseError = null;
    },
  },
});
export const ChallengeRulesActions = ChallengeRulesReducer.actions;

export default ChallengeRulesReducer.reducer;
